import { useEffect, useState } from 'react';
import { fetchAllKnownDetails } from '../api/allKnownDetailsApi';
import type { AllKnownDetailsData, KnownDetailsScope } from '../types';

const UNIFIER_SERVICE_KEY = 'UW_GET_ALL_KNOWN_DETAILS';

const parseAllKnownDetails = (body: any): AllKnownDetailsData | null => {
    const data = body?.responseBody?.[UNIFIER_SERVICE_KEY]?.data?.data;
    return Array.isArray(data?.entities) ? (data as AllKnownDetailsData) : null;
};

export const useAllKnownDetails = (
    orgId?: string,
    refreshKey?: number,
    scope?: KnownDetailsScope,
    enabled: boolean = true,
): AllKnownDetailsData | null => {
    const [loaded, setLoaded] = useState<{ orgId: string; scope?: KnownDetailsScope; data: AllKnownDetailsData } | null>(null);

    useEffect(() => {
        if (!enabled || !orgId) return;
        let active = true;
        fetchAllKnownDetails(orgId, scope)
            .then((body) => {
                const data = parseAllKnownDetails(body);
                if (active && data) setLoaded({ orgId, scope, data });
            })
            .catch(() => undefined);
        return () => {
            active = false;
        };
    }, [orgId, refreshKey, scope, enabled]);

    return enabled && loaded && loaded.orgId === orgId && loaded.scope === scope ? loaded.data : null;
};
